import React from "react";
import SideLogo from "../../media/images/logo/Anthesys_Light_Blue_White.png"; // Adjust the path as needed
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FaUser } from "react-icons/fa";
import { FaSignOutAlt } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <Navbar collapseOnSelect expand="lg">
        <div className="logo-container">
          <a href="/">
            <img src={SideLogo} className="logo" alt="Anthesys Logo" />
          </a>
        </div>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            {user ? (
              <Button 
                variant="outline-danger" 
                onClick={handleLogout}
                className="d-flex align-items-center"
              >
                <FaSignOutAlt className="me-2" /> Logout
              </Button>
            ) : (
              <Button 
                variant="outline-primary" 
                onClick={() => navigate('/login')}
                className="d-flex align-items-center"
              >
                <FaUser className="me-2" /> Login
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Header;
